<div class="app flex-row align-items-center">
    <div class="container d-flex justify-content-center">
        <div class="">
            <div class="col-12">
                <div  class="col-12">
                    <div class=" code-hd d-block row">Scan QR Code</div>
                    <div class=" code-txt d-block row">
                        {{'qrmsg' | translate | async }}
                    </div>
                   
                   <div class="qr-code-img d-block row lead"> 
                        <span id="generated-qr-code"></span>
                    </div>
                    <div class="qr-code-btn d-block row"> 
                        <button type="button" class="btn btn-form-mobile btn-sm btn-qr form-button"
                        (click)="logout()">Logout</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>